/* eslint-disable import/prefer-default-export */
/**
 * @param {string} value
 * @returns {Promise<string>}
 */
export async function sha1(value) {
  return await crypto.subtle.digest('SHA-1', new TextEncoder().encode(value)).then((buffer) => {
    return Array.from(new Uint8Array(buffer))
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('')
  })
}

/**
 * @param {React.ComponentType<any>} Component
 * @param {string} key
 * @returns {Promise<string>}
 */
export async function getUniqueId(Component, key) {
  const hash = await sha1(JSON.stringify({ props: Component.railsProps, key }))
  return `shared-component-${hash}`
}

/**
 * @param {any} value
 * @returns {string}
 */
export function toJSON(value) {
  return JSON.stringify(value).replaceAll('"', '&quot;')
}

/**
 * @param {string} value
 * @returns {any}
 */
export function fromJSON(value) {
  return JSON.parse(value.trim().replaceAll('&quot;', '"'))
}
